// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__Pko-7","fileBtn":"File_fileBtn__2g__s","closeBtn":"File_closeBtn__3VM1G","fileSelected":"File_fileSelected__1YdNj","disabled":"File_disabled__4HeuT"};